export const getWilyabrupData = () => ({
  name: "Wilyabrup",
  country: "Australie",
  region: "Margaret River",
  description: "Wilyabrup est le cœur historique de Margaret River, réputé pour ses Cabernet Sauvignon et Chardonnay de qualité exceptionnelle. Son climat méditerranéen et ses sols granitiques créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Wilyabrup", x: 25, y: 85, color: "#8a4a8a", size: 4 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "0.15 million hectolitres",
    altitude: "50-150m",
    appellations: "Wilyabrup GI",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence océanique, étés chauds et secs, hivers doux",
    soil: "Sols granitiques, argileux, excellente drainage",
    viticulture: "Viticulture traditionnelle, vignobles historiques, rendements limités"
  },
  wineStyles: {
    red: "Cabernet Sauvignon structurés et élégants, Shiraz puissants, assemblages complexes",
    white: "Chardonnay élégants et complexes, Sauvignon Blanc frais, Sémillon aromatiques",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Wilyabrup est le berceau de la viticulture à Margaret River, avec les premiers vignobles plantés dans les années 1960. La sous-région s'est rapidement imposée comme l'une des plus prestigieuses d'Australie.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes rouges, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
    red: ["Cabernet Sauvignon", "Shiraz", "Merlot"]
  },
  keyProducers: ["Vasse Felix", "Cullen", "Leeuwin Estate"],
  notableWines: {
    "cabernet-sauvignon": "Cabernet Sauvignon structurés et élégants",
    "chardonnay": "Chardonnay complexes et aromatiques",
    "shiraz": "Shiraz puissants et structurés"
  }
}); 